import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getSettingsRequest = (query, params) =>
  restRequest({
    uri: 'settings',
    query,
    method: HttpMethods.Get,
    ...params,
  });
